import React from "react";

//components
import Spinner from "../components/Spinner";

let types = {
  "danger": "icon__btn--danger",
  "warning": "icon__btn--warning",
  "info": "icon__btn--info"
};

export default function IconButton(props) {

  let isLoading = props.loading ? <Spinner /> : props.children;

  let classes = `icon__btn ${types[props.variant]}`;

  return (
    <button type={props.type} className={classes} onClick={props.onClick}>
      {isLoading}
    </button>
  );
}